import React from 'react';
import { TextButton } from '@oneaudi/unified-web-components';
import type { VendorCtaSelectorProps } from '../VendorCtaSelector';

const VinRecallCta = ({
  ctaDetails,
  variant,
  vin,
  vehicleType,
  carType,
}: VendorCtaSelectorProps) => {
  const { vinRecallTypeVisibility, vinRecallLabel } = ctaDetails;
  // This CTA should be enabled ONLY for pre-owned Vehicles (both Audi and Non Audi)
  if (carType === 'new') return null;
  // Authorable option to show for either CPO vehicles only or All Pre-Owned vehicles inclding CPO (default)
  if (vinRecallTypeVisibility === 'cpo' && vehicleType !== 'cpo') return null;
  if (vinRecallTypeVisibility === 'non-cpo' && vehicleType === 'cpo') return null;
  return (
    <TextButton
      className="vin-recall-cta"
      variant={variant}
      href={`https://vinrcl.safercar.gov/vin/?vin=${vin}`}
      data-testid="vinRecallCta"
      target="_blank"
      rel="noopener noreferrer"
    >
      {vinRecallLabel ?? 'NHTSA VIN Look up'}
    </TextButton>
  );
};

export default VinRecallCta;
